import { sessionStorageFields } from './sessionStorageFields';

type FieldToStorageKeyMap = {
  [sessionStorageKey in keyof typeof sessionStorageFields]: (typeof sessionStorageFields)[sessionStorageKey]['storageKey'];
};

type Fields = keyof FieldToStorageKeyMap;

const _fieldToStorageKeyMap = Object.entries(sessionStorageFields).reduce((acc, [sessionStorageKey, typedEntry]) => {
  return {
    ...acc,
    [sessionStorageKey]: typedEntry.storageKey,
  };
}, {} as FieldToStorageKeyMap);

const _storage = sessionStorage;

const getStringified = (key: string) => {
  const stringified = _storage.getItem(key);

  if (!stringified) throw new Error(`Failed to get key "${key}" in sessionStorageService.`);

  return stringified;
};

const getParsed = (key: string) => {
  const stringified = getStringified(key);

  try {
    return JSON.parse(stringified);
  } catch {
    return stringified;
  }
};

export const sessionStorageService = {
  get<F extends Fields>(field: F): (typeof sessionStorageFields)[F]['value'] {
    return getParsed(sessionStorageFields[field].storageKey);
  },
  getAsNumber<F extends Fields>(field: F): number {
    return Number(getParsed(sessionStorageFields[field].storageKey));
  },
  getAsBoolean<F extends Fields>(field: F): boolean {
    return Boolean(getParsed(sessionStorageFields[field].storageKey));
  },
  set<F extends Fields>(key: Fields, value: (typeof sessionStorageFields)[F]['value']) {
    const stringified = JSON.stringify(value);
    _storage.setItem(key, stringified);
  },

  fieldToKeyMap: _fieldToStorageKeyMap,
};
